import { useCallback, useSyncExternalStore } from 'react';
import i18n from '../i18n';

// Persists the selected language and switches i18next to it (see src/i18n).
const STORAGE_KEY = 'language';
const DEFAULT_LANGUAGE = 'en';
const CHANGE_EVENT = 'app-language-change';

const read = (): string => {
  try {
    return localStorage.getItem(STORAGE_KEY) || DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

const subscribe = (onChange: () => void) => {
  window.addEventListener(CHANGE_EVENT, onChange);
  window.addEventListener('storage', onChange);
  return () => {
    window.removeEventListener(CHANGE_EVENT, onChange);
    window.removeEventListener('storage', onChange);
  };
};

export function useAppLanguage() {
  const language = useSyncExternalStore(subscribe, read, () => DEFAULT_LANGUAGE);

  const setLanguage = useCallback((next: string) => {
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // storage unavailable — selection just won't persist
    }
    document.documentElement.lang = next;
    void i18n.changeLanguage(next);
    window.dispatchEvent(new Event(CHANGE_EVENT));
  }, []);

  return { language, setLanguage };
}
